<div class="tw-space-y-4 tw-border-b dark:tw-border-gray-800 tw-pb-2">
    <!-- Header -->
    <div class="tw-flex tw-items-center tw-justify-between tw-px-1 tw-pt-3">
        <div class="tw-flex tw-items-center tw-gap-2">
            <div
                class="tw-w-8 tw-h-8 tw-bg-gradient-to-r tw-from-amber-500 tw-to-orange-600 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                <ng-icon name="heroUsers" size="16" class="tw-text-white"></ng-icon>
            </div>
            <h3 class="tw-text-sm tw-font-semibold tw-text-slate-900 dark:tw-text-slate-100 tw-mb-0">
                Connection Requests
            </h3>
        </div>

        @if (totalRequests() > 2) {
        <button (click)="onViewAll()"
            class="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-text-indigo-600 dark:tw-text-indigo-400 hover:tw-text-indigo-700 dark:hover:tw-text-indigo-300 hover:tw-bg-indigo-50 dark:hover:tw-bg-indigo-900/20 tw-rounded-lg tw-transition-all tw-duration-200">
            <ng-icon name="heroEye" size="14"></ng-icon>
            <span>View All ({{ totalRequests() }})</span>
        </button>
        }
    </div>

    <!-- Request List -->
    <div class="tw-space-y-3">
        @for (request of displayedRequests(); track request._id) {
        <div
            class="tw-group tw-relative tw-p-3 tw-bg-white/80 dark:tw-bg-slate-800/80 tw-border tw-border-slate-200/60 dark:tw-border-slate-700/60 tw-rounded-2xl tw-transition-all tw-duration-300 hover:tw-shadow-md hover:tw-shadow-slate-200/40 dark:hover:tw-shadow-slate-900/40 hover:tw-scale-[1.01]">

            <div class="tw-flex tw-items-start tw-gap-3">
                <!-- Avatar -->
                <div class="tw-relative tw-flex-shrink-0">

                    <app-user-avatar [pictureKey]="request.fromUser.profilePictureKey"
                        [pictureTransform]="request.fromUser.pictureTransform" [pictureID]="request.fromUser._id"
                        imgClass="tw-w-10 tw-h-10 tw-object-cover tw-rounded-full tw-ring-2 tw-ring-white dark:tw-ring-slate-800 tw-shadow-lg">
                    </app-user-avatar>

                    <!-- Status Badge -->
                    <div class="tw-absolute -tw-bottom-0.5 -tw-right-0.5">
                        <div class="tw-w-5 tw-h-5 tw-rounded-full tw-border-2 tw-border-white dark:tw-border-slate-800 tw-flex tw-items-center tw-justify-center"
                            [ngClass]="{
                       'tw-bg-amber-500': request.status === 'pending',
                       'tw-bg-green-500': request.status === 'accepted',
                       'tw-bg-red-500': request.status === 'rejected'
                     }">
                            <ng-icon [name]="getStatusIcon(request.status)" size="12" class="tw-text-white">
                            </ng-icon>
                        </div>
                    </div>
                </div>

                <!-- Content -->
                <div class="tw-flex-1 tw-min-w-0">
                    <div class="tw-flex tw-items-start tw-justify-between tw-gap-2 tw-mb-1">
                        <h4
                            class="tw-text-sm tw-font-semibold tw-text-slate-900 dark:tw-text-slate-100 tw-truncate tw-mb-0">
                            {{ request.fromUser.firstName }} {{ request.fromUser.lastName }}
                        </h4>
                        <span class="tw-text-xs tw-text-slate-500 dark:tw-text-slate-400 tw-whitespace-nowrap">
                            {{ request.createdAt | timeAgo }}
                        </span>
                    </div>


                    @if (request.message) {
                    <p class="tw-text-xs tw-text-slate-600 dark:tw-text-slate-400 tw-line-clamp-2 tw-mb-3">
                        "{{ request.message }}"
                    </p>
                    }

                    @if (request.status === 'pending') {
                    <div class="tw-flex tw-items-center tw-gap-2">
                        <!-- Accept Button -->
                        <button (click)="onAcceptRequest(request)" [disabled]="acceptingRequest || rejectingRequest"
                            class="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-bg-gradient-to-r tw-from-green-500 tw-to-green-600 hover:tw-from-green-600 hover:tw-to-green-700 tw-text-white tw-text-xs tw-font-medium tw-rounded-lg tw-transition-all tw-duration-200 hover:tw-scale-105 tw-active:scale-95 tw-shadow-sm disabled:tw-opacity-50 disabled:tw-cursor-not-allowed disabled:hover:tw-scale-100">

                            @if (acceptingRequest) {
                            <!-- Loading spinner -->
                            <svg class="tw-animate-spin tw-w-3.5 tw-h-3.5" viewBox="0 0 24 24" fill="none">
                                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"
                                    class="tw-opacity-25"></circle>
                                <path fill="currentColor" class="tw-opacity-75"
                                    d="m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                            <span>Accepting...</span>
                            } @else {
                            <ng-icon name="heroCheckCircle" size="14"></ng-icon>
                            <span>Accept</span>
                            }
                        </button>

                        <!-- Reject Button -->
                        <button (click)="onRejectRequest(request)" [disabled]="acceptingRequest || rejectingRequest"
                            class="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-bg-slate-100 dark:tw-bg-slate-700 hover:tw-bg-slate-200 dark:hover:tw-bg-slate-600 tw-text-slate-700 dark:tw-text-slate-300 tw-text-xs tw-font-medium tw-rounded-lg tw-transition-all tw-duration-200 hover:tw-scale-105 tw-active:scale-95 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed disabled:hover:tw-scale-100">

                            @if (rejectingRequest) {
                            <!-- Loading spinner -->
                            <svg class="tw-animate-spin tw-w-3.5 tw-h-3.5" viewBox="0 0 24 24" fill="none">
                                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"
                                    class="tw-opacity-25"></circle>
                                <path fill="currentColor" class="tw-opacity-75"
                                    d="m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                            <span>Declining...</span>
                            } @else {
                            <ng-icon name="heroXCircle" size="14"></ng-icon>
                            <span>Decline</span>
                            }
                        </button>
                    </div>
                    }


                    @if (request.status !== 'pending') {
                    <div class="tw-flex tw-items-center tw-gap-1.5">
                        <div class="tw-flex tw-items-center tw-gap-1.5 tw-px-2 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium"
                            [ngClass]="{
                    'tw-bg-green-100 dark:tw-bg-green-900/20 tw-text-green-700 dark:tw-text-green-400': request.status === 'accepted',
                    'tw-bg-red-100 dark:tw-bg-red-900/20 tw-text-red-700 dark:tw-text-red-400': request.status === 'rejected'
                  }">
                            <ng-icon [name]="getStatusIcon(request.status)" size="12"></ng-icon>
                            <span>{{ getStatusLabel(request.status) }}</span>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
        }
    </div>

    <!-- Empty State -->
    @if (requests().length === 0) {
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-8 tw-text-center">
        <div
            class="tw-w-16 tw-h-16 tw-bg-gradient-to-br tw-from-slate-100 tw-to-slate-200 dark:tw-from-slate-800 dark:tw-to-slate-700 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-mb-4">
            <ng-icon name="heroUsers" size="24" class="tw-text-slate-400 dark:tw-text-slate-500"></ng-icon>
        </div>
        <h4 class="tw-text-sm tw-font-medium tw-text-slate-900 dark:tw-text-slate-100 tw-mb-1">
            No connection requests
        </h4>
        <p class="tw-text-xs tw-text-slate-500 dark:tw-text-slate-400 tw-mb-0">
            New connection requests will appear here
        </p>
    </div>
    }
</div>